const routes = [
  {
    path: 'settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '../../../views/Admin/Settings/index.vue'),
    children: [
      {
        path: 'company/:id?',
        name: 'Company',
        component: () => import(/* webpackChunkName: "company-settings" */ '../../../views/Admin/Settings/Company.vue'),
      },
    ],
  },
  {
    path: 'settings/company/:id/ciec',
    name: 'AddCIEC',
    component: () => import(/* webpackChunkName: "company-settings-add-ciec" */ '../../../views/Admin/Settings/AddCIEC.vue'),
  },
  {
    path: 'settings/add-rfc',
    name: 'AddRFC',
    component: () => import(/* webpackChunkName: "settings-add-rfc" */ '../../../views/Auth/AddRFC.vue'),
  },
];

export default routes;
